<template>
  <div>
    <h2>Radio Button States</h2>
    <div class="radio-row">
      <CalicoRadioButton
        v-model="selectedValue"
        :value="1"
      >
        Default
      </CalicoRadioButton>
      <CalicoRadioButton
        v-model="selectedValue"
        :value="2"
      >
        Active
      </CalicoRadioButton>
      <CalicoRadioButton
        v-model="selectedValue"
        :value="3"
        :error="true"
      >
        Error
      </CalicoRadioButton>
      <CalicoRadioButton
        v-model="selectedValue"
        :value="4"
        :disabled="true"
      >
        Disabled
      </CalicoRadioButton>
    </div>
    <p>Selected Value: {{ selectedValue }}</p>
  </div>
</template>

<script>
import CalicoRadioButton from "@/components/calico/radioButton";

export default {
  name: "CalicoRadioButtonPage",
  components: { CalicoRadioButton },
  data() {
    return {
      selectedValue: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.radio-row {
  @include inline-space($space-medium);
  padding: 10px;
  align-items: center;
  background: #F7F7F4;
  height: 100px;
}
</style>
